import React, { useEffect, useState } from "react"
import { motion, AnimatePresence } from "framer-motion"

const ModalShell = ({ children, onClose, zIndex = 200, maxWidth = "sm:max-w-md" }) => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < 640 : false
  )
  useEffect(() => {
    const mq = window.matchMedia("(max-width:639px)")
    const handler = (e) => setIsMobile(e.matches)
    mq.addEventListener("change", handler)
    return () => mq.removeEventListener("change", handler)
  }, [])

  const mobileAnim = {
    initial: { y: "100%", opacity: 0.8 },
    animate: { y: 0, opacity: 1 },
    exit: { y: "100%", opacity: 0 },
  }
  const desktopAnim = {
    initial: { scale: 0.95, opacity: 0, y: 12 },
    animate: { scale: 1, opacity: 1, y: 0 },
    exit: { scale: 0.95, opacity: 0, y: 12 },
  }
  const anim = isMobile ? mobileAnim : desktopAnim

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className={`fixed inset-0 flex justify-center ${isMobile ? "items-end" : "items-center p-4"}`}
      style={{ zIndex, background: "rgba(15,23,42,0.5)", backdropFilter: "blur(2px)" }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      <motion.div
        className={`w-full ${maxWidth} flex flex-col`}
        style={{ maxHeight: "90vh" }}
        {...anim}
        transition={{ duration: 0.26, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.div>
    </motion.div>
  )
}

export default ModalShell
